module.exports = __webpack_public_path__ + "img/defaultAvatar.21a77c59.png";